"use client";

import React from "react";
import { FiCheck, FiArrowRight } from "react-icons/fi";
import { useSelector } from "react-redux";
import NoReviewIcon from "@/Components/Common/Icons/NoReviewIcon";

const ReviewInfoSection = () => {
  const user = useSelector((state) => state?.userData?.userData?.user);
  const isReps = user?.type === "reps";
  const handleWriteReview = () => {
    const reviewsSection = document.getElementById('reviews');
    if (reviewsSection) {
      reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(() => {
        const allElements = reviewsSection.querySelectorAll('div, button, a');
        allElements.forEach((element) => {
          const text = element.textContent?.trim() || '';
          if (text.toLowerCase() === 'write an anonymous review' || 
              (text.toLowerCase().includes('write') && 
               text.toLowerCase().includes('anonymous') && 
               text.toLowerCase().includes('review'))) {
            element.click();
            return;
          }
        });
      }, 800);
    }
  };

  // For reps users, show simple "No reviews yet" without CTA
  if (isReps) {
    return (
      <div className="w-full mt-4 bg-white rounded-xl p-5 border border-gray-100">
        <div className="flex flex-col items-center text-center py-4">
          <NoReviewIcon />
          <h3 className="text-base font-bold text-gray-900 font-poppins mt-3 mb-1">
            No Reviews Yet
          </h3>
          <p className="text-xs text-gray-500 font-poppins">
            Check back later for physician insights.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full mt-4 bg-white rounded-xl p-5 border border-gray-100">
      {/* Header Section */}
      <div className="flex flex-col items-center text-center">
        <span className="text-3xl mb-3">👋</span>
        <h3 className="text-base font-bold text-gray-900 font-poppins mb-1">
          No reviews yet — <span className="text-primary-primaryBlue">Be the first to review</span>
        </h3>
        <p className="text-xs text-gray-500 font-poppins mb-3">
          <FiCheck className="inline w-3 h-3 text-emerald-500 mr-1" />
          100% anonymous · Verified U.S. prescribers only
        </p>
        <p className="text-sm text-gray-600 font-poppins mb-4">
          Your <span className="font-medium text-primary-primaryBlue">45-second review</span> helps colleagues make better decisions.
        </p>
        <button
          onClick={handleWriteReview}
          className="flex items-center gap-2 px-5 py-2.5 bg-primary-primaryBlue text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-all"
        >
          Write Anonymous Review
          <FiArrowRight className="w-4 h-4" />
        </button>
      </div>

      {/* Simple Trust Line */}
      <div className="flex items-center justify-center gap-4 mt-4 pt-4 border-t border-gray-100">
        {["NPI-verified", "No pharma influence", "Real experience"].map((point, i) => (
          <span key={i} className="text-[11px] text-gray-500 font-poppins flex items-center gap-1">
            <FiCheck className="w-3 h-3 text-emerald-500" />
            {point}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ReviewInfoSection;
